/* import __COLOCATED_TEMPLATE__ from './inbox-seat-removal-banner.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();